import React from "react";
import { WHATSAPP_URL } from "@/lib/site";
import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp() {
    return (
        <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-btn"
            aria-label="WhatsApp"
            className="fixed bottom-6 right-6 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-900/20 pl-4 pr-5 py-3 text-sm font-semibold hover:brightness-110 hover:-translate-y-0.5 transition-all"
        >
            <MessageCircle className="h-4 w-4" />
            <span className="hidden sm:inline">WhatsApp</span>
        </a>
    );
}
